<template>
  <div>
    <div class="row sticky-button">
      <div class="col-12 col-sm-7 col-md-5 col-lg-5 px-0">
        <div class="form-group has-label">
          <minus-plus
            :label="`${$t('common_words.activities_number')}: *`"
            @handlePlus="handlePlus"
            @handleMinus="handleMinus"
            :value="model.activity_number"
          />
        </div>
      </div>
    </div>
    <div
      class="row py-3 mb-4 shadow-sm"
      style="border: 0.5px solid #6ba6524d"
      :key="index"
      v-for="index in model.activity_number"
    >
      <div class="col-12 col-md-4 col-xl-4">
        <fg-input
          :label="`${$t('common_words.activity_number')} ${index}: *`"
          class="required-name pl-0"
          ref="name"
          type="text"
          v-model="model.name[index - 1]"
          :name="`common_words.activity_number_${index - 1}`"
          v-validate="modelValidations.name"
          :error="
            getFieldErrorByIndex(
              'common_words.activity_number',
              true,
              index - 1
            )
          "
          placeholder="..."
        ></fg-input>
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-xl-2">
        <fg-input
          :label="`${$t('common_words.code')}: *`"
          class="required-code"
          ref="code"
          type="text"
          v-model="model.code[index - 1]"
          :name="`common_words.code_${index - 1}`"
          v-validate="modelValidations.code"
          :error="getFieldErrorByIndex('common_words.code', true, index - 1)"
          placeholder="..."
        ></fg-input>
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-xl-2">
        <fg-input
          :label="`${$t('common_words.code_homologated')}: *`"
          class="required-homologacion"
          ref="code"
          type="text"
          v-model="model.homologatedCode[index - 1]"
          :name="`common_words.code_row_homologation_${index - 1}`"
          v-validate="modelValidations.homologatedCode"
          :error="
            getFieldErrorByIndex(
              'common_words.code_row_homologation',
              true,
              index - 1
            )
          "
          placeholder="..."
        ></fg-input>
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-xl-2">
        <fg-input
          :label="`${$t('common_words.cost_center')}:`"
          class="input-costCenter"
          ref="costCenter"
          type="text"
          v-model="model.costCenter[index - 1]"
          :name="`common_words.cost_center_${index - 1}`"
          placeholder="..."
        ></fg-input>
      </div>
      <div class="col-12 col-md-4 col-xl-2">
        <div class="has-label">
          <label>{{ $t('common_words.type_capture') }}?: *</label>
          <br />
          <el-select
            filterable
            class="select-primary mb-3 shadow-sm required-catchType"
            v-model="model.catchType[index - 1]"
            :placeholder="`${$t('common_words.select')}...`"
            @clear="model.catchType = []"
            style="width: 100%"
          >
            <el-option
              class="select-primary"
              v-for="item in [
                { id: 'finca', value: 'Finca' },
                { id: 'lote', value: 'Lote' },
              ]"
              :key="item.id + item.value"
              :label="item.value"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-xl-3">
        <fg-input
          :label="`${$t('common_words.minimum')}: *`"
          step="0.01"
          min="0"
          ref="minimum"
          type="number"
          v-model="model.minimum[index - 1]"
          :name="`common_words.minimum_row_${index - 1}`"
          v-validate="modelValidations.minimum"
          :error="
            getFieldErrorByIndex('common_words.minimum_row', true, index - 1)
          "
          placeholder="..."
          @change="validateMinimum(index - 1)"
        ></fg-input>
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-xl-3">
        <fg-input
          :label="`${$t('common_words.maximum')}: *`"
          step="0.01"
          min="0"
          ref="maximum"
          type="number"
          v-model="model.maximum[index - 1]"
          :name="`common_words.maximum_row_${index - 1}`"
          v-validate="modelValidations.maximum"
          :error="
            getFieldErrorByIndex('common_words.maximum_row', true, index - 1)
          "
          placeholder="..."
        ></fg-input>
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-xl-3">
        <div class="form-group has-label">
          <label>{{ $t('common_words.payment_unit') }}*</label>
          <br />
          <el-select
            id="prueba"
            collapse-tags
            filterable
            class="select-primary custom-width-select shadow-sm required-unitPayment"
            size="large"
            v-model="model.payment_unit[index - 1]"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              v-for="option in activityUnit"
              class="select-primary"
              :value="option.id"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-xl-3">
        <div class="form-group has-label">
          <label>{{ $t('common_words.production_unit') }} *</label>
          <br />
          <el-select
            id="prueba"
            collapse-tags
            filterable
            class="select-primary custom-width-select shadow-sm required-unitProduction"
            size="large"
            v-model="model.production_unit[index - 1]"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              v-for="option in activityUnit"
              class="select-primary"
              :value="option.id"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-xl-3">
        <div class="form-group has-label">
          <label>{{ $t('common_words.status') }}</label>
          <el-switch
            v-model="model.enable[index - 1]"
            style="display: block; margin-top: 0.5rem"
            active-color="#6BA652"
            inactive-color="#ff4949"
          >
          </el-switch>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-xl-3">
        <div class="form-group has-label">
          <label>{{ $t('labor.additional_activity') }}?</label>
          <el-switch
            v-model="model.aditional_activity[index - 1]"
            style="display: block; margin-top: 0.5rem"
            active-color="#6BA652"
            inactive-color="#ff4949"
          >
          </el-switch>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-xl-3">
        <div class="form-group has-label">
          <label>{{ $t('labor.group_activities') }}?</label>
          <el-switch
            v-model="model.group_activities[index - 1]"
            style="display: block; margin-top: 0.5rem"
            active-color="#6BA652"
            inactive-color="#ff4949"
          >
          </el-switch>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-xl-3">
        <div class="form-group has-label">
          <label>{{ $t('labor.assist_control') }}?</label>
          <el-switch
            v-model="model.assist_control[index - 1]"
            style="display: block; margin-top: 0.5rem"
            active-color="#6BA652"
            inactive-color="#ff4949"
          >
          </el-switch>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util';
import { Tooltip } from 'element-ui';
import MinusPlus from 'src/components/Forms/MinusPlus.vue';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations.js';

export default {
  components: {
    [Tooltip.name]: Tooltip,
    [MinusPlus.name]: MinusPlus,
  },
  data() {
    return {
      model: {
        activity_id: [],
        name: [],
        code: [],
        homologatedCode: [],
        costCenter: [],
        catchType: [],
        minimum: [],
        maximum: [],
        payment_unit: [],
        production_unit: [],
        aditional_activity: [false],
        group_activities: [false],
        assist_control: [true],
        enable: [true],
        activity_number: 1,
      },
      modelValidations: {
        name: {
          required: true,
        },
        code: {
          required: true,
        },
        homologatedCode: {
          required: true,
        },
        minimum: {
          required: true,
          min_value: 0,
        },
        maximum: {
          required: true,
          min_value: 0,
        },
        activity_number: {
          required: true,
          min_value: 0,
        },
      },
      enable: [],
      minimum: [],
      maximum: [],
      activityUnit: [],
      map: null,
    };
  },
  mixins: [
    MixinPermissions,
    MixinForm,
    MixinAlert,
    MixinLoading,
    MixinValidations,
  ],
  methods: {
    hasActivityData() {
      const fields = [
        'name',
        'code',
        'homologatedCode',
        'costCenter',
        'catchType',
        'minimum',
        'maximum',
        'payment_unit',
        'production_unit',
      ];

      return fields.some((field) =>
        this.model[field].some(
          (value) => value !== null && value !== undefined && value !== ''
        )
      );
    },
    emitValidatedModel() {
      this.$emit('on-validated', {
        ...this.model,
        payment_unit_names: this.opty(
          this.model.payment_unit,
          this.activityUnit
        ),
        production_unit_names: this.opty(
          this.model.production_unit,
          this.activityUnit
        ),
      });
    },
    handlePlus() {
      this.model.activity_number++;
      this.handleNumberChange();
    },
    handleMinus() {
      const minNumber = this.getNumberActivities() || 1;
      if (this.model.activity_number > minNumber) {
        this.model.activity_number--;
        this.handleNumberChange();
      }
    },
    getNumberActivities() {
      let value = this.model.activity_id.length;

      return value;
    },
    handleNumberChange() {
      let codes = [...this.model.code];
      let homologatedCodes = [...this.model.homologatedCode];
      let costCenters = [...this.model.costCenter];
      let catchTypes = [...this.model.catchType];
      let names = [...this.model.name];
      let maximums = [...this.model.maximum];
      let minimums = [...this.model.minimum];
      let payment_units = [...this.model.payment_unit];
      let production_units = [...this.model.production_unit];
      let aditional_activities = [...this.model.aditional_activity];
      let groups_activities = [...this.model.group_activities];
      let assist_controls = [...this.model.assist_control];
      let actEnables = [...this.model.enable];

      for (let i = 0; i <= this.model.activity_number - 1; i++) {
        actEnables.push(true);
      }
      this.model.enable = actEnables;

      Array.from(
        { length: this.model.activity_number - 1 },
        (_, i) => i + 1
      ).forEach((i) => {
        assist_controls.push(true);
      });
      this.model.assist_control = assist_controls;

      if (
        this.model.name.length > 0 &&
        this.model.name.length > this.model.activity_number
      ) {
        this.$set(
          this.model,
          'code',
          codes.splice(0, this.model.activity_number)
        );
        this.$set(
          this.model,
          'homologatedCode',
          homologatedCodes.splice(0, this.model.activity_number)
        );
        this.$set(
          this.model,
          'costCenter',
          costCenters.splice(0, this.model.activity_number)
        );
        this.$set(
          this.model,
          'catchType',
          catchTypes.splice(0, this.model.activity_number)
        );
        this.$set(
          this.model,
          'name',
          names.splice(0, this.model.activity_number)
        );
        this.$set(
          this.model,
          'maximum',
          maximums.splice(0, this.model.activity_number)
        );
        this.$set(
          this.model,
          'minimum',
          minimums.splice(0, this.model.activity_number)
        );
        this.$set(
          this.model,
          'payment_unit',
          payment_units.splice(0, this.model.activity_number)
        );
        this.$set(
          this.model,
          'production_unit',
          production_units.splice(0, this.model.activity_number)
        );
        this.$set(
          this.model,
          'aditional_activity',
          aditional_activities.splice(0, this.model.activity_number)
        );
        this.$set(
          this.model,
          'group_activities',
          groups_activities.splice(0, this.model.activity_number)
        );
        this.$set(
          this.model,
          'assist_control',
          assist_controls.splice(0, this.model.activity_number)
        );
      }
    },
    opty(dataMain, options) {
      const others = [];
      dataMain.forEach((element) => {
        const isFind = options.find((item) => item.id === element);
        if (isFind) others.push(isFind.name);
      });

      return others;
    },
    validate() {
      if (!this.hasActivityData()) {
        this.emitValidatedModel();
        return Promise.resolve(true);
      }

      return this.$validator
        .validateAll()
        .then((res) => {
          this.emitValidatedModel();

          return res;
        })
        .then((resp) => {
          if (!resp) return resp;

          let passed = true;
          const obj = Array.from(
            { length: this.model.activity_number },
            (_, index) => index
          ).forEach((i) => {
            if (!isset(this.model.catchType[i])) {
              this.validationInput('catchType', i);
              passed = false;
            } else if (!isset(this.model.payment_unit[i])) {
              this.validationInput('unitPayment', i);
              passed = false;
            } else if (!isset(this.model.production_unit[i])) {
              this.validationInput('unitProduction', i);
              passed = false;
            }
          });

          if (passed) {
            return true;
          }
        });
    },
    validateMinimum(index) {
      if (
        Number(this.model.minimum[index]) >= Number(this.model.maximum[index])
      ) {
        let minumums = [...this.model.minimum];
        minumums[index] = '';
        this.$set(this.model, 'minimum', minumums);
      }
    },
  },
  created() {
    if (this.isCreate() || this.isUpdate()) {
      Axios.getMasters('works/activityunits/field')
        .then((response) => {
          this.activityUnit = response.data.data;
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));
    } else this.showHideLoading();
  },
  mounted() {
    let editForm = {};
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      this.model.enable = [];
      this.model.aditional_activity = [];
      this.model.group_activities = [];
      this.model.assist_control = [];
      editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.model.activity_number = editForm.activities.length;
      editForm.activities.forEach((element) => {
        this.model.activity_id.push(element.id);
        this.model.name.push(element.name);
        this.model.code.push(element.code);
        this.model.homologatedCode.push(element.homologated_code);
        this.model.costCenter.push(element.cost_center);
        this.model.catchType.push(element.catch_type);
        this.model.minimum.push(element.minimum);
        this.model.maximum.push(element.maximum);
        this.model.payment_unit.push(element.payment_unit);
        this.model.production_unit.push(element.production_unit);
        this.model.aditional_activity.push(
          Number(element.aditional_activity) === 0 ? false : true
        );
        this.model.group_activities.push(
          Number(element.group_activities) === 0 ? false : true
        );
        this.model.assist_control.push(
          Number(element.assist_control) === 0 ? false : true
        );

        if (element.deleted_at) {
          this.model.enable.push(false);
        } else {
          this.model.enable.push(true);
        }
      });
    }
  },
  destroyed() {
    localStorage.removeItem('listFiles');
  },
};
</script>
